import { Box, Stack, Typography } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { Callout } from '@/components/notifications/Callout/Callout';
import type { GraphQLValidationIssue } from '@/graphql/errors';
import { COLORS } from '@/styles/tokens/colors';

export function FormValidationIssues({
  issues,
  onSelectField,
  onDismiss,
}: {
  issues: GraphQLValidationIssue[];
  onSelectField: (fieldId: string) => void;
  onDismiss: () => void;
}) {
  return (
    <Callout severity="error" skipTextWrapper>
      <Stack role="alert" spacing={0.75} width="100%" px={0.5} py={0.5}>
        <Typography variant="title-xs">
          Fix {issues.length === 1 ? 'this problem' : 'these problems'}, then
          publish again.
        </Typography>
        <Stack component="ul" spacing={0.5} m={0} pl={2.5}>
          {issues.map((issue, index) => {
            const { fieldId } = issue;
            return (
              <Box
                component="li"
                key={`${issue.code}-${issue.path}-${fieldId}-${index}`}
              >
                {fieldId ? (
                  <Button
                    size="xs"
                    variant="transparent"
                    onClick={() => onSelectField(fieldId)}
                    sx={{ justifyContent: 'flex-start', height: 'auto', p: 0 }}
                  >
                    {issue.message}
                  </Button>
                ) : (
                  <Typography component="div" variant="body-xs">
                    {issue.message}
                  </Typography>
                )}
                {issue.path && (
                  <Typography
                    component="div"
                    variant="body-xs"
                    sx={{
                      color: COLORS.TEXT.SECONDARY,
                      overflowWrap: 'anywhere',
                    }}
                  >
                    {issue.path}
                  </Typography>
                )}
              </Box>
            );
          })}
        </Stack>
        <Button
          size="xs"
          variant="secondary"
          onClick={onDismiss}
          sx={{ alignSelf: 'flex-start' }}
        >
          Dismiss
        </Button>
      </Stack>
    </Callout>
  );
}
